import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LoggingService } from '../services/logging.service';
import { TenantRouterService } from '../services/tenant-router.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private router: Router,
     private loggingService : LoggingService, private tenantRouter: TenantRouterService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authService.getSessionToken();
    if (token) {
      // Clone the request and add the authorization header
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }

    // Handle errors globally
    return next.handle(request).pipe(
      catchError((errorResponse : HttpErrorResponse) => {
        if (errorResponse.status === 401) {
          // Unauthorized - Token might be invalid or expired
          this.authService.logout();
          this.tenantRouter.logoutRedirect();
        }
        else if(errorResponse.status === 404) {
          this.loggingService.logError('Resource Not found');
        }
        else if(errorResponse.status === 400) {
          this.loggingService.logError('Something wrong with the request');
        }
        else if(errorResponse.status === 500) {
          this.loggingService.logError('Server error');
        }
        else {
          this.loggingService.logError('Unexpected error');
        }
        console.log(errorResponse);
        return throwError(() => errorResponse.error);
      })
    );
  }

}
